export default __webpack_public_path__ + "static/logo-en-0afd9dc9c59df64b38228b11e240ce80.png";